import React, { useEffect, useContext, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import { SESSION_STORAGE } from "../helpers/constants";
import RepairTicketNegotiationView from "./RepairTicketNegotiationView";
import RepairVendorConversationRedirect from "./RepairVendorConversationRedirect";

const RepairConversationRedirect = () => {
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const v = params.get("vendorId");
    if (v) setVendorId(v);
  }, [location.search]);

  useEffect(() => {
    if (!user && !vendorId) {
      const returnUrl = `${location.pathname}${location.search}`;
      try {
        sessionStorage.setItem(SESSION_STORAGE.redirectUrl, returnUrl);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Unable to set redirectUrl in sessionStorage", e);
      }
      navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
    }
  }, [user, vendorId, navigate, location.pathname, location.search]);

  if (!ticketId) {
    return null;
  }

  if (user?.uid) {
    return <RepairTicketNegotiationView ticketId={ticketId} user={user} />;
  }

  return (
    <RepairVendorConversationRedirect ticketId={ticketId} vendorId={vendorId} />
  );
};

export default RepairConversationRedirect;
